import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';

import Logo from 'assets/images/logo.svg';
import { verifyEmail } from 'api/auth/verifications-email/verifications-email';

const VerificationsPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [statusMessage, setStatusMessage] = useState('Verifying your email...');
  const requestSentRef = useRef(false);
  const uidb64 = searchParams.get('uidb64');

  const verifyMutation = useMutation({
    mutationFn: verifyEmail,
    onSuccess: (response: any) => {
      if (response.status === 200) {
      }
      setStatusMessage('Email verified successfully! Redirecting...');
      setTimeout(() => navigate('/login'), 3000);
    },
    onError: () => {
      setStatusMessage('Verification failed. The link may be invalid or expired.');
    },
  });

  useEffect(() => {
    if (!uidb64) {
      setStatusMessage('Invalid verification link.');
      return;
    }

    if (requestSentRef.current) {
      return;
    }

    requestSentRef.current = true;
    verifyMutation.mutate(uidb64);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uidb64]);
  return (
    <div className="auth-page-wrapper pt-5">
      <div className="auth-page-content">
        <div className="container">
          {/* Header / Logo */}
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <a href="https://trojan.systems/" className="d-inline-block auth-logo">
                    <img src={Logo} alt="" height="50" />
                  </a>
                </div>
                <p className="mt-3 fs-15 fw-medium text-primary">Smart pest management</p>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-4">
                <div className="card-body p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Verify Email</h5>
                  </div>

                  <div className="p-2 mt-4 text-center">{statusMessage}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <p className="mb-0 text-muted">© {new Date().getFullYear()} Trojan LLC.</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default VerificationsPage;
